module.exports = __webpack_public_path__ + "static/img/upgrade_bar.7e4037e.png";